module.exports = __webpack_public_path__ + "img/practice.153f6dc5.svg";